import { AppLink } from './AppLink';

export interface Crumb {
  readonly label: string;
  /** A screen to return to; the last crumb (the current screen) has none. */
  readonly to?: string;
}

/** Where the user is ("פרויקט › מסירות"): the last item is the current screen. */
export function Breadcrumbs({ items }: { readonly items: readonly Crumb[] }) {
  if (items.length === 0) return null;
  return (
    <nav className="crumbs" aria-label="מיקום">
      <ol>
        {items.map((item, index) => {
          const last = index === items.length - 1;
          return (
            <li key={`${item.label}-${String(index)}`}>
              {last || item.to === undefined ? (
                <span aria-current={last ? 'page' : undefined}>{item.label}</span>
              ) : (
                <AppLink to={item.to}>{item.label}</AppLink>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
